<template>
  <div>
    <el-dialog
      width="900px"
      custom-class="quota-manage"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      @close="onDialogClose"
    >
      <div slot="title" class="flex justify-content-space-between align-items-center">
        <div style="font-size: 21px;">配额管理</div>
        <div style="padding-right: 50px;" class="flex align-items-center">
          <el-link :underline="false" type="warning" href="https://wiki.frippler.com/#/docs/fs/fcs/90" target="_blank"><i class="el-icon-question font-md" /> 了解接入点配额</el-link>
        </div>
      </div>
      <div class v-loading="loading">
        <div class="quota-remain-card flex align-items-center justify-content-space-between">
          <div style="font-size: 18px" class="text-black">
            剩余配额：
            <span :class="ap_quota_remain === 0 ? 'text-danger' : 'text-success'">{{ ap_quota_remain }}</span>
          </div>
          <div class="operate-btns">
            <el-button v-if="free_trial" size="medium" type="text" class="mr" @click="appalyQuota">申请免费试用</el-button>
            <!-- <el-button size="medium" type="primary" @click="toQuotaBuy">购买配额</el-button> -->
          </div>
        </div>

        <div v-for="(item,index) in list" :key="index" class="quota-list flex justify-content-center">
          <div class="quota-item-card">
            <div class="flex align-items-center mb-xs">
              <div class="font-md text-black bd">预充时长{{ item.precharge_month / 12 }}年</div>
              <el-button v-if="item.total_count - item.used_count" size="mini" plain class="ft" @click="toCreate(item.precharge_month)">去创建</el-button>
            </div>
            <div class="text-right text-muted">
              剩余<span :class="item.total_count - item.used_count == 0 ? 'text-danger' : 'text-success'">{{ item.total_count - item.used_count }}</span>个/共{{ item.total_count }}个
            </div>
            <div class="quota-progress">
              <el-progress
                :percentage="(item.used_count / item.total_count) * 100"
                :stroke-width="10"
                :show-text="false"
                :status="'success'"
                class="quota-progress mt-sm"
              ></el-progress>
            </div>
          </div>
        </div>

      </div>
    </el-dialog>
    <!-- <quota-buy v-if="quotaBuyShow" :show.sync="quotaBuyShow" @change="handleSuccess"/> -->
  </div>
</template>
  
  <script>
import { getQuotaApi, sendFreeTrial } from "@/api/ap/apApi";
export default {
  components: {
    // QuotaBuy: () => import("./QuotaBuy.vue"),
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      list: [],
      ap_quota_remain: 0,
      quotaBuyShow: false,
      free_trial: false,
    };
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      getQuotaApi().then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.ap_quota_remain = res.data.ap_quota_remain;
          this.free_trial = res.data.free_trial;
          this.list = res.data.list;
          this.$emit("change");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    appalyQuota() {
      if (this.$store.state.godStore.certified !== 1) {
        this.$fCertifiedConfirm({
          onConfirm: () => {
            this.$router.push("/fam/certify")
          }
        })
        return
      }
      this.$confirm("确认申请免费试用吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        sendFreeTrial().then((res) => {
          if (!res.errno) {
            this.$message.success(res.message);
            this.fetchData();
            this.$emit("change");
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    // toQuotaBuy() {
    //   if (this.$store.state.godStore.certified !== 1) {
    //     this.$fCertifiedConfirm({
    //       onConfirm: () => {
    //         this.$router.push("/fam/certify")
    //       }
    //     })
    //     return
    //   }
    //   this.quotaBuyShow = true;
    // },

    onDialogClose() {
      this.dialogShow = false;
      this.$emit("change");
    },

    handleSuccess() {
      this.fetchData();
      this.$emit("change");
    },

    toCreate(month) {
      this.dialogShow = false
      this.$emit('create', month)
    }
  },
};
</script>
  
<style lang="scss">
.el-dialog__wrapper > .el-dialog.quota-manage {
  min-height: 680px;
  .el-dialog__body {
    padding-top: 20px;
    padding-bottom: 30px;
    .el-progress.quota-progress {
      .el-progress-bar__outer {
        border-radius: 5px;
        background-color: #eef0f5;
      }

      .el-progress-bar__inner {
        border-radius: 5px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.quota-manage {
  .quota-remain-card {
    width: 800px;
    height: 80px;
    border-radius: 6px;
    background-color: rgba(238, 240, 245, 1);
    text-align: center;
    margin: 0 auto;
    padding: 0 20px;
  }
  .quota-list {
    margin-top: 20px;
    .quota-item-card {
      width: 800px;
      height: 120px;
      border-radius: 5px;
      background-color: rgba(255, 255, 255, 1);
      border: 1px solid rgba(220, 223, 230, 1);
      padding: 20px;
    }
  }
  .quota-list:last-child {
    margin-bottom: 0;
  }
}
</style>
  

